module.exports = __webpack_public_path__ + "static/media/empty-notebook@3x.15892fff.png";